import { GrowthBook } from "@growthbook/growthbook-react";
import { thirdPartyTrackingPlugin, autoAttributesPlugin } from "@growthbook/growthbook/plugins";
import { Locale } from "app-settings/localesAndCurrencies";
import { Cookies } from "react-cookie";
import { v4 as uuidv4 } from "uuid";
import { COOKIE_DOMAIN } from "constants/cookies";

const GROWTHBOOK_GBUUID_COOKIE = "gbuuid";

function initGrowthbookCookie() {
  const cookies = new Cookies();

  if (!cookies.get(GROWTHBOOK_GBUUID_COOKIE)) {
    cookies.set(GROWTHBOOK_GBUUID_COOKIE, uuidv4(), {
      path: "/",
      domain: COOKIE_DOMAIN,
      sameSite: "lax" as const,
    });
  }

  return cookies.get(GROWTHBOOK_GBUUID_COOKIE);
}

export function loadGrowthbook(locale: Locale) {
  const gbCookie = initGrowthbookCookie();

  const growthbook = new GrowthBook({
    attributes: {
      app: "webapp-funnel",
      page_language: locale,
    },
    apiHost: "https://cdn.growthbook.io",
    clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
    enableDevMode: import.meta.env.MODE !== "production",
    plugins: [
      autoAttributesPlugin({ uuid: gbCookie, uuidAutoPersist: false }),
      thirdPartyTrackingPlugin({ trackers: ["gtm"] }),
    ],
  });

  return growthbook;
}
